import { readUserAuthFromLocalStorage } from 'src/app/core/http/user-auth';
import { ClearUser, EActionType as EUserActionType } from '../../user/user.actions';
import { ActionsUnion, EActionType } from './two-factor-authentication-state.actions';
import { TTwoFactorAuthenticationState } from './two-factor-authentication-state.model';

export function getStoredTwoFactorAuthentication(): TTwoFactorAuthenticationState {
  return readUserAuthFromLocalStorage().twoFactorAuthentication ?? {};
}

export function twoFactorAuthenticationReducer(
  state: TTwoFactorAuthenticationState = {},
  action: ActionsUnion | ClearUser,
): TTwoFactorAuthenticationState {
  switch (action.type) {
    case EActionType.UPDATE_TWO_FACTOR_AUTHENTICATION:
      return { ...state, ...action.payload };

    case EUserActionType.CLEAR_USER:
      return {};

    default:
      return state;
  }
}
